import React from "react";

interface ThrowErrorProps {
  shouldThrow?: boolean;
  errorMessage?: string;
}

/**
 * Test component that throws an error during render.
 * Use this to test ErrorBoundary functionality.
 *
 * @example
 * <ErrorBoundary>
 *   <ThrowError shouldThrow={true} errorMessage="Test error!" />
 * </ErrorBoundary>
 */
export const ThrowError: React.FC<ThrowErrorProps> = ({
  shouldThrow = true,
  errorMessage = "Test error from ThrowError component"
}) => {
  if (shouldThrow) {
    throw new Error(errorMessage);
  }

  return <div>No error thrown</div>;
};
